module.exports = __webpack_public_path__ + "img/http-website.1ab43d02.svg";